module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_lifetime_cl.169bce84.png";